import React, { useEffect, useState } from "react";
import {getUserById} from "../../../../utils/ParserUtilities"
import { useStateValue } from "../../../../state/context";

import InfoCell from "../InfoCell";
import ButtonEmpty from "../../../button/ButtonEmpty";
import Button from "../../../button/Button";


import "../../../../styles/wolly.css";
import "../../../../styles/search/detail/job-detail-container.css";

export default function ClientContainer() {
    const [{user,jobDetails}] = useStateValue();

    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [jobState, setJobState] = useState(null);
    const [hubspotLink, setHubspotLink] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      fetchData()
    }, [jobDetails]);
   
    const fetchData=async ()=>{
          try {
            let client = jobDetails.clientInfo
            let job = jobDetails.job
            setName(client?.get("Name"));
            setPhone(client?.get("Phone"));
            setEmail(client?.get("email"));
            setHubspotLink(client?.get("HubspotLink"));
            setJobState(job?.get("State"));
            setLoading(false);
        } catch (error) {
            console.error("error getting client data: ",error);
        }
    }

    return (
        <section className="infoContainer">
            <div style={{display: "flex", flex: 1}}>
                <div style={{display: "flex", flex: 1}}>
                    <label className="title">Datos del cliente</label>
                </div>
                {hubspotLink && (
                    <div
                        style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "flex-end"
                        }}
                    >
                        <ButtonEmpty
                            buttonText="Ver en Hubspot"
                            onClick={() => {
                                window.open(hubspotLink, "_blank");
                            }}
                        />
                    </div>
                )}
            </div>
            <div className="detailContainer  flex-justify-between">
                <InfoCell
                    title="Nombre del cliente"
                    data={loading ? "Cargando..." : name}
                    halfLeft
                />
                <InfoCell
                    title="Número de teléfono"
                    data={loading ? "Cargando..." : phone}
                    halfRight
                />
            </div>
            <div style={{ alignItems: "end"}} className="detailContainer  flex-justify-between">
                <InfoCell
                    title="Email"
                    data={loading ? "Cargando..." : email}
                    halfLeft
                />
            
             {!user?.isGoldWoller && !loading  && (<Button
                        style={{ margin: "0 auto", height: 36, padding: 0, width: 110, backgroundColor: "#000000", borderColor: "#000000", color: "#FFE235" }}
                        buttonText={"WhatsApp"}
                        onClick={()=>window.open(`https://whatsapp.wollyplatform.app/contacto/%2B${phone.match(/(\+34)/) ? phone.replace("+","") : "34"+phone}`, '_blank')}
                        className={"noMessages"}
                    />)}
            </div>
        </section>
    );
}
